import client from './apolloClient';

export default { client };
